<template>
    <div class="minimised-player" style="position:fixed;z-index:9999999999 !important" ref="minimizedplayerMainWrapper">
        <div class="maximise-icon-wrapper">
            <svg v-if="!['Tasks','chat','share'].includes(selectedModule) && enablePreviewDocker" width="25" height="25" v-on:click="maximisePlayer()" viewBox="0 0 16 16" class="bi bi-box-arrow-up-left" fill="currentColor" style="position: relative;top: -1px;" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M7.364 3.5a.5.5 0 0 1 .5-.5H14.5A1.5 1.5 0 0 1 16 4.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 3 14.5V7.864a.5.5 0 1 1 1 0V14.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H7.864a.5.5 0 0 1-.5-.5z"/>
                <path fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 0 1H1.707l8.147 8.146a.5.5 0 0 1-.708.708L1 1.707V5.5a.5.5 0 0 1-1 0v-5z"/>
            </svg>
             <svg width="35" height="35" v-on:click="closeMiniPlayer()" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
        <div class="min-player" ref="miniplayerwrapper">
            <!-- <embed  src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
            <template v-if="isVideoFile">
                <div>
                    <video-player ref="videoPlayerEl" v-if="isPlayerCanBeLoaded"  @controller="setController" @metaDataLoaded="playerFullyLoaded" :options="videoOptions" style="height:100%;width:100%"/>
                </div>
            </template>
            <customAudioPlayer @audioDuration="handleAudioLoaded" :key="audioPlayerFileInfo && audioPlayerFileInfo._id" :buttonHeight="'height:26px !important;'" ref="audioPlayerComponent" :subclipDetails="subclipDetails" style="bottom: 24px;border-radius:0px !important;" class="audio-player" :isBorderRequired="false" v-if="isAudioFile" :fileInfo="audioPlayerFileInfo"></customAudioPlayer>
          <!--    <audio v-if="isAudioFile" id="audio-player-id" ref="audioPlayerRef" @loadedmetadata="audioPlayerFullyLoaded()" class="audio-player" controls="controls" controlslist="nodownload">
                <source :src="audioUrl" type="audio/mpeg" />
            </audio> -->
            <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
            <img v-if="isImageFile || isAudioFile" :src="getThumbnailPath(selectedFile)" @error="replaceByDefaultImage">
        </div>
    </div>
</template>

<script>
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js" ;
import {mapMutations,mapActions, mapGetters} from "vuex"
import VideoPlayer from "../core/VideoPlayer.vue";
import drag from '@branu-jp/v-drag';
import subclipPreviewMixin from '../../mixins/SubclipPreviewMixin.js';
import customAudioPlayer from '../customAudioPlayer/AudioPlayerComponent.vue';
export default {
    name:'miniPlayerComponent',
     directives: {
        drag
    },
    mixins:[subclipPreviewMixin],
    props:["selectedFile", "selectedModule","subclipDetails","disablePreviewDocker","transcriptPlayObject", 'autoPlay'],
    watch:{
        selectedFile(newVal, oldVal){// eslint-disable-line no-unused-vars
          if(newVal._id != oldVal._id){
                if((newVal && newVal.asset_type && newVal.asset_type == 'subclip'  && (!newVal.proxy_info || Object.keys(newVal.proxy_info).length == 0))){
                    this.initializeSubclipPreview(newVal);
                    return;
                }else{
                    try{
                        this.removeTimeLineMarkers();
                    }catch(e){console.log(e)}
                }

            try{
                if(this.videoFrameCallbackID) {
                    console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                    this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                }
            }catch(e){console.log(e)}

            if(newVal && newVal.mime_type && newVal.mime_type.startsWith("video")){
                if (this.getLowresPath(newVal) != this.getLowresPath(oldVal)){
                    this.videoOptions.sources = [{
                        src:this.getLowresPath(newVal),
                        type: "video/mp4"
                    }]
                    // if (this.controller.player && !this.controller.player.paused()){
                    //     this.controller.restartPlayer(this.videoOptions.sources[0])
                    // }
                    this.controller.player.src(this.videoOptions.sources);
                    this.controller.player.load();
                }
            }else if(newVal && newVal.mime_type && newVal.mime_type.startsWith("audio")){
                if (this.getAudiowaveform(newVal) != this.getAudiowaveform(oldVal)){
                    this.audioPlayerFileInfo = newVal;
                    this.audioUrl = this.getAudiowaveform(newVal)
                    document.getElementById("audio-player-id").load(); 
                }
            }
          }
        },
        subclipDetails(newVal, oldVal){
            if(newVal && Object.keys(newVal).length){
                if(newVal._id != oldVal._id){
                    if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
                        this.transcriptPlayObject={};
                        if(this.isAudioFile){
                            this.$refs.audioPlayerComponent.playSubclipArea(newVal);
                            return;
                        }
                        this.addSubclipMarkers(newVal);
                    }
                }
            }
        },

       transcriptPlayObject(newVal,oldVal){
            console.log("oldVal : ",typeof(oldVal))
            if(newVal && Object.keys(newVal).length){
                //convert trancsript inout similar to subclips in out, as both are the same, and reuse the marker support
                let convertedObj = {markers:{start:newVal['media_in'], end:newVal["media_out"]}}
                if(this.isVideoFile){

                    try{
                        this.removeTimeLineMarkers();
                    }catch(e){console.log(e)}
                    setTimeout(()=>{
                        this.addSubclipMarkers(convertedObj);
                    },10)
                    this.controller.player.currentTime(newVal.media_in/1000);
                    this.controller.player.play();
                }else if(this.isAudioFile){
                    this.subclipDetails={}
                    this.$refs.audioPlayerComponent.setCurrentTime(newVal.media_in/1000);
                    setTimeout(()=>{
                        this.$refs.audioPlayerComponent.playSubclipArea(convertedObj);
                    },10)
                }
            }
        }
    },
    data(){
        return{
            enablePreviewDocker: true,
            actionsOnPlayer: false,
            audioUrl:null,
            controller:{},
            supportedVideoWidth:450,
            videoOptions: {
				autoplay: false,
                controls: true,
                nativeTextTracks: true,
                controlBar:{
                    'pictureInPictureToggle': false,
                },
				sources: [],
                preload: "metadata", //loadmetadata such as duration required for range slider, won't load whole video
			},
            isPlayerCanBeLoaded:false,
            audioPlayerFileInfo:null,
        }
    },
    computed:{
        isAudioFile(){
            let v = false;
            try {
                if(Object.prototype.hasOwnProperty.call(this.selectedFile,'mime_type') && this.selectedFile.mime_type.startsWith("audio")){
                    v = true;
                }   
                
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            try {
                if(this.selectedFile && Object.prototype.hasOwnProperty.call(this.selectedFile,'markers') 
                  && Object.prototype.hasOwnProperty.call(this.selectedFile.markers,'mime_type')){
                    v = this.selectedFile.markers.mime_type == 'audio';
                }   
                
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            return v;
        },
        isVideoFile(){
            let v = false;
            try {
                if(this.selectedFile && this.selectedFile.asset_type && this.selectedFile.asset_type == 'subclip' && !this.isAudioFile && (!this.selectedFile.subclip_type || ["soft","smart","image_captioned"].includes(this.selectedFile.subclip_type)))
                   v = true;
            } catch (err) {
                console.error(`[isVideoFile][1][files][Error while checking filetype-${err}]`)
            }
            try {
                if(Object.prototype.hasOwnProperty.call(this.selectedFile,'mime_type') && this.selectedFile.mime_type.startsWith("video")){
                     v = true;
                }   
            } catch (err) {
                console.error(`[isVideoFile][2][files][Error while checking filetype-${err}]`)
            }
            return v;
        },
        isImageFile(){
            try {
                return (
                    (this.selectedFile && Object.prototype.hasOwnProperty.call(this.selectedFile, 'mime_type') && this.selectedFile.mime_type &&
                        (this.selectedFile.mime_type.startsWith("image") || this.selectedFile.mime_type.startsWith("audio") || this.selectedFile.mime_type.startsWith("doc")))
                    ||
                    (Object.keys(this.subclipDetails).length && Object.prototype.hasOwnProperty.call(this.subclipDetails, 'markers') && Object.prototype.hasOwnProperty.call(this.subclipDetails.markers, 'mime_type') && this.subclipDetails.markers.mime_type === 'audio')
                );
            } catch (err) {
                console.error(`[isImageFile][files][Error while checking filetype-${err}]`);
            }
            return false;
        },
        ...mapGetters("registry",["getDontPlayOverlayScreenOverMiniplayerAssetDoc"])
    },
    methods:{
        handleMiniPlayerKeyBoardShortcuts(event){
            let keyCode = event.keyCode || event.which;
            let pressedElement = String(event.target.nodeName).toLowerCase();
            if(pressedElement == 'input' || pressedElement == 'textarea' || pressedElement == 'select' ) return true;
            let videoAudioRef = null;
            if(this.isVideoFile){
                videoAudioRef = this.$refs.videoPlayerEl.$el.querySelector('video');
            }

            if(this.isAudioFile){
                videoAudioRef = this.$refs.audioPlayerComponent.$el.querySelector('audio');
            }
             
            if(keyCode === 32){ //spacebar
                event.preventDefault(); // don't allow to scroll
                try{
                    if(this.$route && this.getDontPlayOverlayScreenOverMiniplayerAssetDoc.includes(this.$route.name)){
                         return; // don't play when tag-metadata window is opened on top , it will avoid 2 times playing
                    }
                }catch(e){console.log(e)}

                if(videoAudioRef && videoAudioRef.paused){
                    videoAudioRef.play()
                }else{
                    videoAudioRef.pause();
                }
            }

        },
        handleAudioLoaded(){
            // Changed the condition from 'this.transcriptPlayObject.media_in' to "'media_in' in this.transcriptPlayObject", bcz, when medi_in value is 0 the check is failing
            if(this.transcriptPlayObject && 'media_in' in this.transcriptPlayObject){
                setTimeout(()=> {
                this.$refs.audioPlayerComponent.setCurrentTime(this.transcriptPlayObject.media_in/1000);
                this.$refs.audioPlayerComponent.playSubclipArea({markers:{start:this.transcriptPlayObject['media_in'], end:this.transcriptPlayObject["media_out"]}});
                })
            }
            if(this.selectedFile && Object.prototype.hasOwnProperty.call(this.selectedFile,'markers')){
               this.$refs.audioPlayerComponent.playSubclipArea(this.selectedFile.markers)
            }
        },
        getMasterAssetForSubclip(fileObj){
            return new Promise((resolve) => {
                this.getAssetInfoFromServer({params:{assetId:fileObj.master_asset_id}}).then((data) => {
                    if(data && data.asset)
                       resolve(data.asset);
                })
            });
        },
        async initializeSubclipPreview(fileObj){
           let asset = await this.getMasterAssetForSubclip(fileObj);
           if(this.isVideoFile){
               this.videoOptions.sources = [{
                    src:this.getLowresPath(asset),
                    type: "video/mp4"
                }]
                this.isPlayerCanBeLoaded = true;
                // if (this.controller.player && !this.controller.player.paused()){
                //     this.controller.restartPlayer(this.videoOptions.sources[0])
                // }
                this.controller.player.src(this.videoOptions.sources);
                this.controller.player.load();
                this.controller.player.pause();
           }
           if(this.isAudioFile){
                let masterClipAlreadyLoaded = false;
                if(this.audioPlayerFileInfo && this.audioPlayerFileInfo._id == asset._id){
                    masterClipAlreadyLoaded = true;
                }
                this.audioPlayerFileInfo = asset;
                this.subclipDetails = {"markers":fileObj.markers};
                this.audioUrl = this.getAudiowaveform(asset);
                if(masterClipAlreadyLoaded){
                    this.$nextTick(()=>{
                       this.$refs.audioPlayerComponent.playSubclipArea({"markers":fileObj.markers});
                    });
                }
            }
        },
        addSubclipMarkers(markinMarkoutObj, donotPlayVideo=false){
         /*    if(this.subclipDetails && Object.keys(this.subclipDetails).length){ // change to subclip from metadata dock
                markinMarkoutObj = this.subclipDetails;
            } */
            this.$refs.videoPlayerEl.$el.classList.add('sub-clip-markin-markout-play');
            let start = this.getMarkerValue(markinMarkoutObj.markers.start);
            let end = this.getMarkerValue(markinMarkoutObj.markers.end);
            this.addMarkersToTimeline([{time:start,name:'markin'},{time:end,name:'markout'}]);
            setTimeout(()=> {
                this.addLineBetweenMarkers();
            },100);
            try{
                if(this.videoFrameCallbackID) {
                    console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                    this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                }
            }catch(e){console.log(e)}
            this.controller.player.currentTime(start);
            if(this.controller.player.paused() && this.autoPlay && !donotPlayVideo) this.controller.player.play();
            this.$nextTick(()=>{
                this.currentMarkoutValue = end;
                // alert('inside');
                this.videoFrameCallbackID = this.controller.player.requestAnimationFrame(this.videoFrameCallback);
            });
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        playSubClipPreview(markinMarkoutObj,callback){
            try{
              this.controller.player.currentTime(markinMarkoutObj.markin);
                //this.controller.player.play();
                try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                this.controller.player.on('timeupdate',() =>{ 
                    if(this.controller.player.currentTime() >= markinMarkoutObj.markout){
                        this.controller.player.pause();
                    if(callback && typeof callback == 'function') callback('stopPlayer');
                    try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                    }
                });
            }catch(e){
               console.log(e);
            }
        },
        playerFullyLoaded(){
            this.$nextTick(() => {
                let vw = this.controller.player.el().querySelector('video').videoWidth;
                let vh = this.controller.player.el().querySelector('video').videoHeight;
                console.log(`controller.player.el().querySelector('video')`,this.controller.player.el().querySelector('video').videoHeight);
                let vwhr = vw / vh;
                let newHeight = this.supportedVideoWidth / vwhr;
                console.log('vw,vh,vwhr',vw,vh,vwhr,'newHeight',newHeight,this.controller.player.el().querySelector('video'));
                console.log(this.$refs.miniplayerwrapper);
                // this.$refs.miniplayerwrapper.style.setProperty('height',`${newHeight}px`,'important');
                // this.$refs.minimizedplayerMainWrapper.style.setProperty('height',`${newHeight + 23}px`,'important');
                // this.$refs.videoPlayerEl.$el.querySelector('.video-js').style.setProperty('height',`${newHeight}px`,'important');

                if(this.selectedFile && this.selectedFile.asset_type && this.selectedFile.asset_type == 'subclip' && (!this.selectedFile.subclip_type || ["soft","smart","image_captioned"].includes(this.selectedFile.subclip_type))){
                    this.addSubclipMarkers(this.selectedFile);
                   this.transcriptPlayObject = {};
               }

                if(this.subclipDetails && Object.keys(this.subclipDetails).length && this.subclipDetails.asset_type && this.subclipDetails.asset_type == 'subclip' && (!this.subclipDetails.subclip_type || ["soft","smart","image_captioned"].includes(this.subclipDetails.subclip_type))){
                    this.addSubclipMarkers(this.subclipDetails);
                    this.transcriptPlayObject = {};
                }

                if(this.transcriptPlayObject && Object.keys(this.transcriptPlayObject).length){ 
                    this.subclipDetails={}
                    setTimeout(()=>{
                    this.controller.player.currentTime(this.transcriptPlayObject.media_in/1000);
                    this.controller.player.play();
                    if('media_in' in this.transcriptPlayObject && this.transcriptPlayObject['media_in']>=0 && 'media_out' in this.transcriptPlayObject){
                    //convert trancsript inout similar to subclips in out, as both are the same, and reuse the marker support
                    let convertedObj = {start:this.transcriptPlayObject['media_in'], end:this.transcriptPlayObject["media_out"]}
                    this.addSubclipMarkers({markers:convertedObj});
                    }
                },100)
                }
            });
        },
        audioPlayerFullyLoaded(){
            this.$nextTick(()=>{
                if(this.transcriptPlayObject && Object.keys(this.transcriptPlayObject).length){
                    this.$refs.audioPlayerRef.currentTime = (this.transcriptPlayObject.media_in/1000);
                    this.$refs.audioPlayerRef.play();
                    if('media_in' in this.transcriptPlayObject && this.transcriptPlayObject['media_in']>=0 && 'media_out' in this.transcriptPlayObject){
                        //convert trancsript inout similar to subclips in out, as both are the same, and reuse the marker support
                        let convertedObj = {start:this.transcriptPlayObject['media_in'], end:this.transcriptPlayObject["media_out"]}
                        this.addSubclipMarkers({markers:convertedObj});
                    }
                }
            });
        },
        handleFullScreenRequest(){
           if(document.querySelectorAll('.subclip-timeline-marker') && document.querySelectorAll('.subclip-timeline-marker').length){
                if(this.controller.player.isFullscreen()){
                    setTimeout(() => {
                        this.addLineBetweenMarkers();
                    },100);
                }else{
                    this.addLineBetweenMarkers();
                }
            }
        },
        setController(controller){
            this.controller = controller;
            try{
               this.controller.player.off("fullscreenchange", this.handleFullScreenRequest);
            }catch(e){console.log(e)}
            this.controller.player.on("fullscreenchange", this.handleFullScreenRequest);
        },
        showActionsOnPlayer(){
            this.actionsOnPlayer = ! this.actionsOnPlayer;
        },
        maximisePlayer(){
            this.$emit("maximisePlayer");
        },
        closeMiniPlayer(){
            this.$emit("closeMiniPlayer")
        },
        getThumbnailPath(file){
          return Utils.getThumbnailPathfromFileInfo(file)
        },
        getLowresPath(file){
          return Utils.getLowresPathfromFileInfo(file)
        },
        getAudiowaveform(file){
            return Utils.getAudiowaveformFromFileInfo(file)
        },
        handleFileUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let path = notification.message.path
            let parent_path = notification.message.parent_path
            if (this.selectedFile.path == path){
                if (this.selectedFile.mime_type.startsWith("video")){
                    Object.assign(this.selectedFile, notification.message)

                    this.videoOptions.sources = [{
                            src:this.getLowresPath(notification.message),
                            type: "video/mp4"
                        }]
                    if (  this.controller.player){
                        this.controller.restartPlayer(this.videoOptions.sources[0])
                    }
                }else if (this.selectedFile.mime_type.startsWith("audio")){
                    this.audioUrl = this.getAudiowaveform(this.selectedFile)
                }else if (this.basicAssetInfo.mime_type.startsWith("image")){
                    Object.assign(this.basicAssetInfo, notification.message)
                }
                console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
            }
            }
        },
        registerForNotification(){
            this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"MiniPlayer"})
        },
        unRegisterForNotification(){
            this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"MiniPlayer"})
        },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("assets",["getAssetInfoFromServer"]),
    },
    beforeDestroy(){
        this.unRegisterForNotification();
        try{
            if(this.videoFrameCallbackID) {
                console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
            }
        }catch(e){console.log(e)}
        const el = this.$refs.minimizedplayerMainWrapper;
        if (el && el.parentNode === document.body) {
            document.body.removeChild(el);
        }
        window.removeEventListener('keydown', this.handleMiniPlayerKeyBoardShortcuts);
    },
    created(){
        if(this.disablePreviewDocker){
            this.enablePreviewDocker = false
        }
        if(this.selectedFile && this.selectedFile.asset_type && this.selectedFile.asset_type == 'subclip' &&  (!this.selectedFile.subclip_type || ["soft","smart","image_captioned"].includes(this.selectedFile.subclip_type))){
            this.getMasterAssetForSubclip(this.selectedFile).then((data) => {
                if(this.isVideoFile){
                    this.videoOptions.sources = [{
                        src:this.getLowresPath(data),
                        type: "video/mp4"
                    }];
                    this.isPlayerCanBeLoaded = true;
                }
                if(this.isAudioFile){
                   this.audioPlayerFileInfo = data;
                   this.subclipDetails = {"markers":this.selectedFile.markers};
                   this.audioUrl = this.getAudiowaveform(data)
                }
              });
            return;
        }
        this.isPlayerCanBeLoaded = true;
           
        if (this.selectedFile.mime_type.startsWith("video")){
            this.videoOptions.sources = [{
                        src:this.getLowresPath(this.selectedFile),
                        type: "video/mp4"
					}]
        }else if (this.selectedFile.mime_type.startsWith("audio")){
            this.audioPlayerFileInfo = this.selectedFile;
            this.audioUrl = this.getAudiowaveform(this.selectedFile)
        }
    },
    components:{
        // myVideo
        VideoPlayer,
        customAudioPlayer
    },
    emits:["maximisePlayer","closeMiniPlayer"],
    mounted(){
        window.addEventListener('keydown', this.handleMiniPlayerKeyBoardShortcuts);

        const el = this.$refs.minimizedplayerMainWrapper;

        // Escape modal stacking context
        document.body.appendChild(el);

        let startX, startY, startLeft, startTop;

        el.addEventListener('mousedown', (e) => {
            // Only drag from maximise-icon-wrapper, ignore clicks on SVGs/buttons/player
            if (!e.target.closest('.maximise-icon-wrapper')) return;

            e.preventDefault();
            startX = e.clientX;
            startY = e.clientY;
            startLeft = el.offsetLeft;
            startTop = el.offsetTop;

            const onMove = (e) => {
            el.style.left = startLeft + (e.clientX - startX) + 'px';
            el.style.top  = startTop  + (e.clientY - startY) + 'px';
            };

            const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            };

            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onUp);
        });
    }
}
</script>


<style scoped lang="scss">
.minimised-player{
    height: 300px;
    width: 450px;
    border: 1px solid #3a3a3a;
    position: fixed;
    background: #0d0d0d;
    bottom: 0px;
    inset-inline-end: 1%;
    display:flex;
    flex-direction:column;
    align-items: flex-end;
    .maximise-icon-wrapper{
        height:40px;
        float:inline-end;
        width:100%;
        text-align: end;
        display: flex;
        align-items: center;
        justify-content: end;
        svg{
            padding-inline-end:3px;
            color: #aaa
        }
    }
    .min-player{
        width: 100%;
        height: 90%;
            img{
                height:100% !important;
                width:100%;
                max-width: 100%;
                max-height: 100%;
                border-radius: 7px;
                -o-object-fit: contain;
                object-fit: contain;
            }
        }
}

.maximise-icon-wrapper svg{
    &:hover{
        color: #eee;
    }
}

div.minimised-player div.min-player img[src^="data:image/svg+xml;charset=utf-8"]{
    height: 70% !important;
    padding: 26px;
}

video{
    height:100% !important;
    width:100% !important;
    outline: unset !important;
}

::v-deep{
    .vjs_video_3-dimensions, .video-js{
        height:253px !important;
        width:100% !important;
    }
    .video-js{
        height:253px !important;
        width:100% !important;
    }

    .sub-clip-markin-markout-play .video-js .vjs-play-progress {
      background-color: #28cfd8;
  }
  .sub-clip-markin-markout-play .video-js .vjs-play-progress:before {
      font-size: 1.8em!important;
      z-index: 99!important;
      top: -0.43333333333em;
      color: #28cfd8;
  }
  .vjs-sub-clip-marker
  {
    position: absolute;
    background: #ea4863;
    width: 3px;
    height: 18px;
    top: -7px;
    z-index: 30;
    margin-inline-start: -3px;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .sub-clip-markin-markout-play .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
  }
} 

  .dragged-element {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    font-size: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    text-align: center;
    transition: all 0.4s linear;
    transition-property: background-color;
  }

  .audio-player{
    position: absolute;
    bottom: 2px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}
</style>

